module.exports = __webpack_public_path__ + "media/images/badges/stride/milestone-4_inactive-640f61ccb54e1ed660a52a9485bc5610.svg";